import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Home from './ui/component/home';
import AlertMessage from './ui/elements/alert/index';
import './App.css';

const App = () => {
  const alertMessage = useSelector((state) => state.alert.alertMessage);
  const [content, setContent] = useState(null);

  useEffect(() => {
    if (alertMessage && alertMessage.success === false) {
      setContent(<AlertMessage alertMessage={alertMessage} />);
    } else {
      setContent(
        <div className="App">
          <Router>
            <Routes>
              <Route element={<Home />} exact path="/:key?" />
            </Routes>
          </Router>
        </div>
      );
    }
  }, [alertMessage]);

  return (
    <div>{content}</div>
  );
}

export default App;
